export default function Marquee() {
  const items = [
    "US Bookkeeping", "Form 1040 — Individual", "Form 1065 — Partnership",
    "Form 1120 — C-Corp", "Form 1120-S — S-Corp", "Payroll Processing",
    "Sales & Use Tax", "Virtual CFO & MIS", "90+ US Clients", "12 US States Served",
  ];
  return (
    <div
      data-testid="editorial-marquee"
      className="marquee-paused relative border-y border-line bg-white py-6 overflow-hidden"
      aria-label="Services ticker"
    >
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
            {items.map((item) => (
              <span key={`${copy}-${item}`} className="flex items-center">
                <span className="font-display text-xl sm:text-2xl font-semibold text-slate-400 whitespace-nowrap px-6">
                  {item}
                </span>
                <span className="h-2 w-2 rotate-45 bg-gradient-to-r from-teal to-torange shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-paper to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-paper to-transparent" />
    </div>
  );
}
